export const getToken = state => state.token
export const getSalesFlag = state => state.sales_flag



// WEBPACK FOOTER //
// ./src/store/getters.js